document.addEventListener('DOMContentLoaded', function() {

  if(document.querySelectorAll('.product_wrapper').length > 0){
    let setTimeOut;
    setTimeOut = setTimeout(() => {
      let getpre = document.querySelector('.custom-pre-order-attribute').value;
      if(getpre){
        if(getpre=='preorder'){
          document.querySelector('.pre_order_head').style.display = "block";
        }
      }
    }, 4000);
  }
  // COLLECTION TAB
  const tabTitles = document.querySelectorAll('.collecitons_tab_title');
  if (tabTitles.length > 0) {
      tabTitles[0].classList.add('tab_title_active');
  }
  tabTitles.forEach(tabTitle => {
      tabTitle.addEventListener('click', function() {
          // Remove 'tab_title_active' class from all tab titles
          tabTitles.forEach(tab => tab.classList.remove('tab_title_active'));
          // Add 'tab_title_active' to the clicked tab
          this.classList.add('tab_title_active');
  
          // Fetch data for the clicked tab
          const dataUrl = this.getAttribute("data-url");
          
          // Fetch and update content
          fetch(dataUrl) 
              .then(response => {
                  if (!response.ok) throw new Error('Network response was not ok');
                  return response.text();
              })
              .then(htmlText => {
                  const doc = new DOMParser().parseFromString(htmlText, "text/html");
                // console.log(doc)
                  const extractedHtml = doc.querySelector('#product-grid');
  
                  if (extractedHtml) {
                      const collectionGrid = extractedHtml.innerHTML;
                      const productGridElements = document.querySelectorAll('.featured_collections_tab_product_grid');
                      
                      // Update all grid elements
                      productGridElements.forEach(grid => grid.innerHTML = collectionGrid);
                  }
              })
              .catch(error => console.error('Error fetching data:', error.message));
      });
  });

  // COLLECTION SLIDER
  const mediaQuery = window.matchMedia('(min-width: 991px)')
  if (mediaQuery.matches) {
      var swiper = new Swiper(".featured_collection_tab_sliders", {
      slidesPerView: 4,
      spaceBetween: 0,
      scrollbar: {
        el: ".swiper-scrollbar",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  }

  // TAB WITH CONTENT
  let $tab__title = document.querySelectorAll('.tab__title');
  let $tab__content = document.querySelectorAll('.tab_with_content__content_grid');
  if($tab__title.length > 0){
    $tab__title[0].classList.add('tab__active');
  }
  if($tab__content.length > 0){
    $tab__content[0].classList.add('tab__active')
  }
  $tab__title.forEach(function(tabTitle) {
    tabTitle.addEventListener('click',function () {
      $tab__title.forEach(tabTil => tabTil.classList.remove("tab__active"));
      this.classList.add("tab__active");
      const TitleAttrVal = this.getAttribute('data-tab-title');
      // alert(TitleAttrVal)
      $tab__content.forEach(function(tabContent) {
         const ContentAttrVal = tabContent.getAttribute('data-tab-content');
        // alert(ContentAttrVal)
        if(TitleAttrVal == ContentAttrVal){
          tabContent.classList.add("tab__active")
        }
        else{
          tabContent.classList.remove('tab__active');
        }
      });
    });
  });

  // TESTIMONIAL
  var swiper = new Swiper(".swiper-container", {
  slidesPerView: 1,
  loop: true,
  centeredSlides: false,
  spaceBetween: 30,
  pagination: {
      el: ".swiper-pagination",
      clickable: true
  },
  speed: 1000, // Set transition speed to 1 second
  autoplay: {
      delay: 10000, // Set delay to 5 seconds
      enabled: true,
    }
  });


  // MAIN PRODUCT TAB 

  let mainProductTabTitle = document.querySelectorAll('.main_product_tab_title');
  let mainProductTabContent = document.querySelectorAll('.main_product_tab_content');

  if(mainProductTabTitle.length > 0){
    mainProductTabTitle[0].classList.add('main_product_tab_title_active');
  }
  if(mainProductTabTitle.length > 0){
    mainProductTabContent[0].classList.add('main_product_tab_title_active');
  }
  mainProductTabTitle.forEach(function(tabTitle) {
    tabTitle.addEventListener('click',function() {  
    mainProductTabTitle.forEach(TabTitle => TabTitle.classList.remove('main_product_tab_title_active'));
    this.classList.add('main_product_tab_title_active');
       const tabTitleAttrVal = tabTitle.getAttribute('tab-title');
      mainProductTabContent.forEach(function(tabContent) {
        const tabContentAttrVal = tabContent.getAttribute('tab-content');
        if(tabTitleAttrVal == tabContentAttrVal){
          tabContent.classList.add('main_product_tab_title_active');
        }
        else{
          tabContent.classList.remove('main_product_tab_title_active');
        }
      });
    });
    
  });


  // HOME PAGE TESTIMONIAL
  // document.addEventListener('DOMContentLoaded', () => {
  //   const marquee = document.querySelector('.marquee_content_image');
  //   const originalContent = marquee.querySelector('.original_content');
    
  //   const duplicateContent = originalContent.cloneNode(true);
  //   duplicateContent.classList.add('duplicate_content');
  //   marquee.appendChild(duplicateContent);
  
  //   const contentWidth = originalContent.offsetWidth;
  //   marquee.style.animationDuration = `${contentWidth / 100}s`;
  // });
// document.addEventListener('DOMContentLoaded', () => {
//   const marquee = document.querySelector('.marquee_content_image');
//   const originalContent = marquee.querySelector('.original_content');

//   // Clone the original content
//   const duplicateContent = originalContent.cloneNode(true);
//   duplicateContent.classList.add('duplicate_content');
//   marquee.appendChild(duplicateContent);

//   // Get the width of the original content
//   const contentWidth = originalContent.offsetWidth;

//   // Ensure the marquee container is wide enough
//   marquee.style.minWidth = `${contentWidth * 2}px`;

//   // Adjust animation duration based on content width
//   marquee.style.animationDuration = `${contentWidth / 100}s`;

//   // Make sure the marquee scrolls smoothly
//   marquee.style.overflow = 'hidden';
// });

         
         
  // MAIN PRODUCT STAR RATING
    const reviewButton = this.querySelector(".rating-wrapper .rating");  
    if (reviewButton) { 
        reviewButton.addEventListener('click', function() { 
            mainProductTabContent.forEach(function(element, index) { 
                element.classList.remove('main_product_tab_title_active');
                mainProductTabTitle[index].classList.remove('main_product_tab_title_active');
                console.log(index);  
            }); 
    
            document.querySelector('#descripTab--review').classList.add('main_product_tab_title_active');   
            const tabsProductReviews = document.querySelector('#tabs__product_reviews');
            tabsProductReviews.classList.add('main_product_tab_title_active');
    
            const offset = 100; // Adjust this value as needed
            const elementPosition = tabsProductReviews.getBoundingClientRect().top + window.pageYOffset;
            window.scrollTo({
                top: elementPosition - offset,
                behavior: 'smooth',    
            });
        }); 
    }


  
  
});

           

